/// <reference path="../types.js" />

import { recursionCritical } from "./recursionCritical";
import { isEdge } from "./utils";

/**
 * Garante que o objeto possui o flag criticalPath como true.
 * @param {Node|Edge} item
 */
function ensureCritical(item) {
  item.data = { ...(item.data || {}), criticalPath: true };
}

/**
 * Tenta novamente marcar todos os elementos do caminho crtico at estabilizar (verso original).
 * @param {Elements} elements
 * @param {number} [oldElementsLength=0]
 * @returns {Elements}
 */
export function newTry(elements, oldElementsLength = 0) {
  let elementsVar = JSON.parse(JSON.stringify(elements));
  let oldLength = oldElementsLength;

  elementsVar.forEach((item) => {
    if (isEdge(item)) {
      const hasUnmarkedNeighbour = elementsVar.find(
        (neighbour) =>
          (neighbour.id === item.source || neighbour.id === item.target) &&
          neighbour.data?.criticalPath !== true
      );

      if (hasUnmarkedNeighbour && item.data?.criticalPath === true) {
        ensureCritical(item);
        elementsVar = recursionCritical(item.id, elementsVar);
      }
    } else {
      const hasCriticalTarget = elementsVar.find(
        (it) => it.target === item.id && it.data?.criticalPath === true
      );
      const hasCriticalSource = elementsVar.find(
        (it) => it.source === item.id && it.data?.criticalPath === true
      );

      const needsPropagation =
        (!hasCriticalTarget || !hasCriticalSource) &&
        !(hasCriticalTarget === undefined && hasCriticalSource === undefined);

      if (needsPropagation && item.data?.criticalPath === true) {
        ensureCritical(item);
        elementsVar = recursionCritical(item.id, elementsVar);
      }
    }
  });

  const criticalCount = elementsVar.filter((el) => el.data?.criticalPath).length;
  if (criticalCount !== oldLength) {
    oldLength = criticalCount;
    return newTry(elementsVar, oldLength);
  }

  return elementsVar;
}
